import {
  Directive,
  OnInit,
  ComponentFactoryResolver,
  ViewContainerRef, HostBinding
} from "@angular/core";

@Directive({
  selector: "[tjBackButton]",
})
export class TjBackButtonDirective implements OnInit {

  @HostBinding('class') containerClass = 'backbutton-container';

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit() {
   
  }
}
